"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function StrikethroughIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "m8.232,9.131h-1.7v-.85c0-3.659,2.977-6.636,6.637-6.636,2.178,0,4.219,1.07,5.46,2.863l.484.699-1.398.967-.483-.699c-.924-1.334-2.442-2.131-4.062-2.131-2.722,0-4.937,2.214-4.937,4.936v.85Z" }),
        react_1.default.createElement("path", { d: "m10.831,22.534c-2.178,0-4.219-1.07-5.46-2.863l-.484-.698,1.398-.968.483.699c.924,1.334,2.442,2.131,4.062,2.131,2.722,0,4.937-2.215,4.937-4.937v-.85h1.7v.85c0,3.659-2.977,6.636-6.637,6.636Z" }),
        react_1.default.createElement("rect", { x: "1.237", y: "11.15", width: "21.525", height: "1.7" })));
}
exports.default = StrikethroughIcon;
